import { render, staticRenderFns } from "./ProvidersEmployers.vue?vue&type=template&id=24f8f164&"
import script from "./ProvidersEmployers.vue?vue&type=script&lang=js&"
export * from "./ProvidersEmployers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports